import { Helpers } from '../../core';

export const getQuickViewProps = Helpers.memoize(
    product => ({
        product: { title: product.name, ...product, variation: 'gift-guide' },
        images: product.images.map(image => ({ src: image.lrg })),
    }),
    product => product.sku,
);

export const TILEVARIANT = {
    classic: 'classic',
    visId: '2024',
    LifeStyleTile: '2025',
};

export const GRIDLAYOUT = {
    classic: 'classic',
    threeColumn: 'gg-3-col',
    fourColumn: 'gg-4-col',
    fiveColumn: 'gg-5-col',
};

export default { getQuickViewProps, TILEVARIANT, GRIDLAYOUT };
